import { InternalParticipant } from '@/types/api';
import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import ProfileImage from '@/components/Record/SubjectContent/ProfileImage';
import CustomCheckBox from '../../CustomCheckBox';

type P = {
  passport: InternalParticipant;
  isChecked?: boolean;
  handleChange?(passportId: string): void;
  rightContents?: ReactNode;
  disabled?: boolean;
  isFocused?: boolean;
  searchKeyword?: string;
};

const PassportItem = ({
  passport,
  isChecked,
  handleChange,
  rightContents,
  disabled,
  isFocused,
  searchKeyword,
}: P) => {
  const {
    passportId,
    name,
    positionName,
    departmentName,
    divisionName,
    profileImageUrl,
  } = passport;

  const renderHighlightedName = (
    text: string,
    highlight: string | undefined,
  ) => {
    if (!highlight) return text;
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    return (
      <>
        {parts.map((part, i) =>
          part.toLowerCase() === highlight.toLowerCase() ? (
            <span
              key={i}
              style={{ color: 'var(--dk-accent, var(--Portal-Color-Point-color, #06C))' }}
            >
              {part}
            </span>
          ) : (
            part
          ),
        )}
      </>
    );
  };

  return (
    <StyledLabel
      disabled={disabled}
      isChecked={isChecked}
      isFocused={isFocused}
      onClick={() => handleChange && handleChange(passportId)}
    >
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {handleChange && (
          <CustomCheckBox checked={isChecked || false} disabled={disabled} />
        )}
        <ProfileImage
          url={profileImageUrl}
          size={40}
          id={`${passport.passportId}-profile`}
        />
        <div>
          <div
            style={{ fontSize: '14px', fontWeight: '400', lineHeight: '20px' }}
          >
            {renderHighlightedName(name, searchKeyword)}{' '}
            {`${positionName ?? '-'}`}
          </div>
          <div
            style={{
              fontSize: '12px',
              fontWeight: '400',
              lineHeight: '18px',
              color: 'var(--dk-text-secondary, #888D96)',
            }}
          >{`${divisionName} ${departmentName}`}</div>
        </div>
      </div>
      {rightContents}
    </StyledLabel>
  );
};

export default PassportItem;

const StyledLabel = styled.div<{
  disabled?: boolean;
  isChecked?: boolean;
  isFocused?: boolean;
}>`
  display: flex;
  align-items: center;
  height: fit-content;

  padding: 4px;
  border-radius: 4px;
  justify-content: space-between;

  background-color: ${({ isChecked, isFocused }) => {
    if (isFocused) return '#e0e0e0';
    return isChecked ? '#f3f5f6' : 'none';
  }};
  :hover {
    background-color: ${({ disabled }) =>
      disabled ? 'none' : 'rgba(249, 250, 251)'};
  }
`;
